import React, { useState, useEffect } from 'react';
import '../assets/css/contact.css';
import { Link } from 'react-router-dom';

const Contact = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // FAQ Data
    const faqs = [
        {
            question: "How long do AR Perfumes last?",
            answer: "Our premium fragrances use high-concentration essential oils ensuring a long-lasting scent that stays with you for 12-24 hours depending on the specific formula and skin type."
        },
        {
            question: "Are your perfumes ethically sourced?",
            answer: "Yes, we are committed to sustainability. All our ingredients are ethically sourced, and our products are 100% cruelty-free."
        },
        {
            question: "What is your return policy?",
            answer: "We offer a 14-day return policy for unopened products in their original packaging. Please contact our support team to initiate a return."
        },
        {
            question: "Can I get a sample before buying?",
            answer: "Yes! We offer a discovery set that includes 5 of our best-selling fragrances so you can find your signature scent before committing to a full-size bottle."
        }
    ];

    const [activeFaq, setActiveFaq] = useState(null);

    const toggleFaq = (index) => {
        if (activeFaq === index) {
            setActiveFaq(null);
        } else {
            setActiveFaq(index);
        }
    };

    return (
        <>
            <div className="contact-page perfume-contact-theme">
                {/* 1. Luxury Hero Section */}
                <section className="luxury-hero" style={{
                    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url("https://images.unsplash.com/photo-1594035910387-fea47794261f?auto=format&fit=crop&q=80&w=2000")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed',
                    padding: '150px 0 100px',
                    textAlign: 'center',
                    color: 'white'
                }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <h1 className="display-3 fw-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Let's Connect with AR Perfume</h1>
                                <p className="lead mb-0" style={{ fontWeight: 300, letterSpacing: '1px' }}>
                                    Experience the essence of luxury. Reach out to us for inquiries, elegant gifting solutions, or expert fragrance advice.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 2. Contact Information Cards */}
                <section className="contact-info-cards py-5 my-4">
                    <div className="container">
                        <div className="row g-4">
                            <div className="col-md-4">
                                <div className="info-card elegant-card text-center p-4 h-100">
                                    <div className="icon-wrapper mb-3">
                                        <i className="fas fa-phone-alt fs-2 text-gold"></i>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Call Us</h4>
                                    <p className="mb-0 text-muted">+34 600099123</p>
                                    <p className="text-muted small">Mon - Fri, 9am - 6pm</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="info-card elegant-card text-center p-4 h-100">
                                    <div className="icon-wrapper mb-3">
                                        <i className="fas fa-envelope-open-text fs-2 text-gold"></i>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Email Us</h4>
                                    <p className="mb-0 text-muted">rambabuy721@gmail.com</p>
                                    <p className="text-muted small">We reply within 24 hours</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="info-card elegant-card text-center p-4 h-100">
                                    <div className="icon-wrapper mb-3">
                                        <i className="fas fa-map-marker-alt fs-2 text-gold"></i>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Visit Store</h4>
                                    <p className="mb-0 text-muted">123 Fragrance Avenue</p>
                                    <p className="text-muted small">Paris, France 75001</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 3. Why Choose AR Perfume */}
                <section className="why-choose-us bg-light py-5">
                    <div className="container py-4">
                        <div className="text-center mb-5">
                            <h2 className="fw-bold" style={{ fontFamily: "inherit" }}>The AR Promise</h2>
                            <div className="divider mx-auto my-3" style={{ width: '50px', height: '2px', backgroundColor: '#d4af37' }}></div>
                        </div>
                        <div className="row g-4 justify-content-center">
                            <div className="col-lg-3 col-md-6 text-center">
                                <div className="promise-card p-4 h-100 bg-white rounded shadow-sm" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="promise-icon-wrapper mb-4" style={{ height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                        </svg>
                                    </div>
                                    <h5 className="fw-600 mb-3" style={{ fontFamily: "inherit" }}>Premium Quality</h5>
                                    <p className="text-muted small mb-0" style={{ lineHeight: '1.6' }}>Crafted with the finest ingredients globally sourced for pure excellence.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 text-center">
                                <div className="promise-card p-4 h-100 bg-white rounded shadow-sm" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="promise-icon-wrapper mb-4" style={{ height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                                            <path d="M17 12a5 5 0 0 0-5-5"></path>
                                            <path d="M12 17a5 5 0 0 1-5-5"></path>
                                        </svg>
                                    </div>
                                    <h5 className="fw-600 mb-3" style={{ fontFamily: "inherit" }}>Long-Lasting</h5>
                                    <p className="text-muted small mb-0" style={{ lineHeight: '1.6' }}>High concentration formulas ensuring scents that stay with you all day.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 text-center">
                                <div className="promise-card p-4 h-100 bg-white rounded shadow-sm" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="promise-icon-wrapper mb-4" style={{ height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                                        </svg>
                                    </div>
                                    <h5 className="fw-600 mb-3" style={{ fontFamily: "inherit" }}>Trusted Experience</h5>
                                    <p className="text-muted small mb-0" style={{ lineHeight: '1.6' }}>Thousands of satisfied customers worldwide who trust our brand.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 text-center">
                                <div className="promise-card p-4 h-100 bg-white rounded shadow-sm" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="promise-icon-wrapper mb-4" style={{ height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="1" y="3" width="15" height="13"></rect>
                                            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                                            <circle cx="5.5" cy="18.5" r="2.5"></circle>
                                            <circle cx="18.5" cy="18.5" r="2.5"></circle>
                                        </svg>
                                    </div>
                                    <h5 className="fw-600 mb-3" style={{ fontFamily: "inherit" }}>Fast Support</h5>
                                    <p className="text-muted small mb-0" style={{ lineHeight: '1.6' }}>Dedicated customer support team ready to assist your journey.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 4. Our Fragrance Journey */}
                <section className="journey-section py-5">
                    <div className="container py-5">
                        <div className="row align-items-center">
                            <div className="col-lg-6 mb-4 mb-lg-0">
                                <img src={require('../assets/images/for-her/image-4.png')} alt="Perfume Creation" className="img-fluid rounded shadow-lg" />
                            </div>
                            <div className="col-lg-6 px-lg-5">
                                <h2 className="fw-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Our Fragrance Journey</h2>
                                <p className="text-muted mb-4" style={{ lineHeight: '1.8' }}>
                                    At AR Perfume, we believe that a fragrance is more than just a scent; it's an invisible accessory that defines your presence. Our journey began with a simple vision: to craft extraordinary, luxurious perfumes that evoke emotion and leave a lasting impression.
                                </p>
                                <p className="text-muted mb-4" style={{ lineHeight: '1.8' }}>
                                    Every bottle represents our unwavering commitment to elegance, quality, and the art of fine perfumery. We invite you to discover your signature scent and join our legacy of refined luxury.
                                </p>
                                <button className="btn btn-outline-dark px-4 py-2" style={{ borderRadius: '0', letterSpacing: '1px' }}>LEARN MORE</button>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 5. Customer Experience Highlights */}
                <section className="stats-section bg-dark text-white py-5" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url("https://images.unsplash.com/photo-1588405748880-12d1d2a59f75?auto=format&fit=crop&q=80&w=2000")', backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                    <div className="container py-4">
                        <div className="row text-center g-4">
                            <div className="col-md-3 col-6">
                                <h2 className="display-4 fw-bold text-gold mb-0">10k+</h2>
                                <p className="text-uppercase small letter-spacing-2">Happy Customers</p>
                            </div>
                            <div className="col-md-3 col-6">
                                <h2 className="display-4 fw-bold text-gold mb-0">50+</h2>
                                <p className="text-uppercase small letter-spacing-2">Premium Scents</p>
                            </div>
                            <div className="col-md-3 col-6">
                                <h2 className="display-4 fw-bold text-gold mb-0">99%</h2>
                                <p className="text-uppercase small letter-spacing-2">Satisfaction Rate</p>
                            </div>
                            <div className="col-md-3 col-6">
                                <h2 className="display-4 fw-bold text-gold mb-0">25k+</h2>
                                <p className="text-uppercase small letter-spacing-2">Orders Delivered</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 6. Frequently Asked Questions */}
                <section className="faq-section py-5 my-4">
                    <div className="container w-75">
                        <div className="text-center mb-5">
                            <h2 className="fw-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Frequently Asked Questions</h2>
                            <div className="divider mx-auto my-3" style={{ width: '50px', height: '2px', backgroundColor: '#d4af37' }}></div>
                        </div>
                        <div className="accordion-custom">
                            {faqs.map((faq, index) => (
                                <div key={index} className="faq-item border-bottom py-3" onClick={() => toggleFaq(index)} style={{ cursor: 'pointer' }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 className="mb-0 fw-bold" style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.1rem' }}>{faq.question}</h5>
                                        <span className="fs-5">{activeFaq === index ? '-' : '+'}</span>
                                    </div>
                                    {activeFaq === index && (
                                        <div className="faq-answer pt-3 text-muted">
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* 7. Premium Call-to-Action Section */}
                <section className="cta-section py-5 bg-light text-center">
                    <div className="container py-4">
                        <h2 className="fw-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Discover Your Signature Fragrance with AR Perfume</h2>
                        <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
                            <a href="tel:+34600099123" className="btn btn-dark px-4 py-2" style={{ borderRadius: '0', letterSpacing: '1px' }}>CALL US</a>
                            <a href="mailto:rambabuy721@gmail.com" className="btn btn-outline-dark px-4 py-2" style={{ borderRadius: '0', letterSpacing: '1px' }}>EMAIL US</a>
                            <Link to="/products" className="btn text-white px-4 py-2" style={{ backgroundColor: '#d4af37', border: 'none', borderRadius: '0', letterSpacing: '1px' }}>SHOP COLLECTION</Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Contact;
